import React from "react";

function AIMagic(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path
        d="M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5C3.82843 1.5 4.5 2.17157 4.5 3C4.5 3.82843 3.82843 4.5 3 4.5C2.17157 4.5 1.5 3.82843 1.5 3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        aimagic-rule="evenodd"
        d="M10.1665 12C10.1665 11.3557 10.6888 10.8334 11.3332 10.8334C11.9775 10.8334 12.4998 11.3557 12.4998 12C12.4998 12.6444 11.9775 13.1667 11.3332 13.1667C10.6888 13.1667 10.1665 12.6444 10.1665 12Z"
        fill="currentColor"
      />
      <path
        d="M6.72244 3.67348C6.89215 3.05122 7.77477 3.05122 7.94447 3.67348L8.85846 7.02476C8.87399 7.0817 8.91847 7.12618 8.9754 7.14171L12.3267 8.05569C12.9489 8.2254 12.9489 9.10802 12.3267 9.27773L8.9754 10.1917C8.91847 10.2072 8.87399 10.2517 8.85846 10.3087L7.94447 13.6599C7.77477 14.2822 6.89215 14.2822 6.72244 13.6599L5.80845 10.3087C5.79293 10.2517 5.74845 10.2072 5.69151 10.1917L2.34023 9.27773C1.71797 9.10802 1.71797 8.2254 2.34023 8.05569L5.69151 7.14171C5.74845 7.12618 5.79293 7.0817 5.80845 7.02476L6.72244 3.67348Z"
        fill="currentColor"
      />
      <path
        d="M14.6667 3.66671C14.6667 3.40899 14.4577 3.20004 14.2 3.20004C13.4269 3.20004 12.8 2.57319 12.8 1.80004C12.8 1.54233 12.591 1.33337 12.3333 1.33337C12.0756 1.33337 11.8667 1.54233 11.8667 1.80004C11.8667 2.57319 11.24 3.20004 10.4667 3.20004C10.209 3.20004 10 3.40899 10 3.66671C10 3.92442 10.209 4.13337 10.4667 4.13337C11.24 4.13337 11.8667 4.76 11.8667 5.53337C11.8667 5.79109 12.0756 6.00004 12.3333 6.00004C12.591 6.00004 12.8 5.79109 12.8 5.53337C12.8 4.76 13.4269 4.13337 14.2 4.13337C14.4577 4.13337 14.6667 3.92442 14.6667 3.66671Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoAIMagic = React.memo(AIMagic);
export default MemoAIMagic;
